import React from "react";
import Heroslider from "./Heroslider";
import Header from "../Includes/Header";
import Footer from "../Includes/Footer";
import { Link } from "react-router-dom";
import CounterSection from "./CounterSection";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import VisitorsCounter from "../Components/VisitorsCounter";
import Chatbot from "../Components/Chatbot";
export default function Home() {
  const fadeUp = {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
  };
  const slideLeft = {
    hidden: { opacity: 0, x: -120 },
    visible: { opacity: 1, x: 0 },
  };

  const slideRight = {
    hidden: { opacity: 0, x: 120 },
    visible: { opacity: 1, x: 0 },
  };

  const fadeDown = {
    hidden: { opacity: 0, y: -120 },
    visible: { opacity: 1, y: 0 },
  };
  const fadeIn = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  };

  return (
    <>
      <main className="boxed_wrapper ">
        <Header />
        <Heroslider />

        
        <div class="container">
  <div class="row">
    <div class="col-lg-4 col-md-6 col-12"></div>
    <div class="col-lg-4 col-md-6 col-12"></div>
    <div class="col-lg-4 col-md-6 col-12"></div>
  </div>
</div>
        <div
          data-elementor-type="wp-page"
          data-elementor-id={1452}
          className="elementor elementor-1452"
        >
          <style
            dangerouslySetInnerHTML={{
              __html:
                "\n                @media screen and (max-width: 1000px) {\n                        {\n                            {\n                            WRAPPER\n                        }\n                    }\n\n                    .wps_floating_img_area {\n                        display: none !important;\n                    }\n                }\n            ",
            }}
          />

          {/* feature section  */}
          <motion.section
            className="feature-section"
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            <div className="elementor-widget-container">
              <motion.h2
                className="elementor-heading-title elementor-size-default feature-heading"
                variants={fadeUp}
                transition={{ duration: 0.8 }}
              >
                What We Provide
              </motion.h2>
            </div>

            <div className="feature-container">
              {/* Box 1 */}
              <motion.div
                className="feature-box"
                variants={fadeUp}
                transition={{ duration: 0.9, delay: 0.2 }}
                whileHover={{ scale: 1.05 }}
              >
                <img src="/shape-6.png" alt="" className="feature-bg" />
                <div className="feature-content">
                  <div className="feature-icon">
                    <i className="icon-8"></i>
                  </div>
                  <h3 className="feature-title">Dumpster Sizes</h3>
                  <p className="feature-text">
                    Choosing the right dumpster size helps <br /> manage waste
                    efficiently.
                  </p>
                </div>
              </motion.div>

              {/* Box 2 */}
              <motion.div
                className="feature-box"
                variants={fadeUp}
                transition={{ duration: 0.9, delay: 0.35 }}
                whileHover={{ scale: 1.05 }}
              >
                <img src="/shape-6.png" alt="" className="feature-bg" />
                <div className="feature-content">
                  <div className="feature-icon">
                    <i className="icon-9"></i>
                  </div>
                  <h3 className="feature-title">Waste Collection</h3>
                  <p className="feature-text">
                    All kinds of waste—household,
                    <br /> commercial, construction, <br /> and recyclables—are
                    collected
                  </p>
                </div>
              </motion.div>

              {/* Box 3 */}
              <motion.div
                className="feature-box"
                variants={fadeUp}
                transition={{ duration: 0.9, delay: 0.5 }}
                whileHover={{ scale: 1.05 }}
              >
                <img src="/shape-6.png" alt="" className="feature-bg" />
                <div className="feature-content">
                  <div className="feature-icon">
                    <i className="icon-10"></i>
                  </div>
                  <h3 className="feature-title">Pickup Schedule</h3>
                  <p className="feature-text">
                    Waste is collected on a set schedule <br /> to keep your
                    area clean and <br /> organized.
                  </p>
                </div>
              </motion.div>
            </div>
          </motion.section>

          <section
            className="elementor-section elementor-top-section elementor-element elementor-element-34c544d9 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="34c544d9"
            data-element_type="section"
            data-settings='{"background_background":"classic"}'
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-673257cc"
                data-id="673257cc"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-690d92c3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="690d92c3"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-85454e3"
                        data-id="85454e3"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-3d24b828 elementor-widget elementor-widget-heading"
                            data-id="3d24b828"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Service Industry
                              </h2>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-4ddaf736 elementor-widget elementor-widget-heading"
                            data-id="4ddaf736"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                A wide range of waste disposal services
                              </h2>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-148cea7d elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="148cea7d"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-e67dda9 wastix_services_clomun wastix_services_clomun_01"
                        data-id="e67dda9"
                        data-element_type="column"
                        data-settings='{"background_background":"classic"}'
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-121a9bb4 wastix_industry_img_01 elementor-widget elementor-widget-image"
                            data-id="121a9bb4"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container service-img-wrapper">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={350}
                                height={120}
                                src="/sw.webp"
                                className="attachment-large size-large wp-image-161 service-card-img"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-25871c5e wastix_img_02 elementor-widget elementor-widget-image"
                            data-id="25871c5e"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container ">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={202}
                                height={173}
                                src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/icon-bg-1.png"
                                className="attachment-large size-large wp-image-164"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-6c20ec9c wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                            data-id="6c20ec9c"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-12" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-592df290 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                            data-id="592df290"
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="https://23july.hostlin.com/wastix/garbage-pickup/">
                                    <span className="elementor-icon-list-text">
                                      Solid Waste Management
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-2bfd66ec elementor-widget elementor-widget-text-editor"
                            data-id="2bfd66ec"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              We offer efficient Solid Waste Management through
                              proper collection, segregation, recycling, and
                              eco-friendly{" "}
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-5de46553 elementor-view-framed wastix_boxshadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                            data-id="5de46553"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <Link
                                  className="elementor-icon"
                                  to="/solid-waste-management"
                                >
                                  <i aria-hidden="true" className="icon-7" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-29255008 wastix_services_clomun wastix_services_clomun_01"
                        data-id={29255008}
                        data-element_type="column"
                        data-settings='{"background_background":"classic"}'
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-42bda40e wastix_industry_img_01 elementor-widget elementor-widget-image"
                            data-id="42bda40e"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container service-img-wrapper">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={350}
                                height={210}
                                src="/containimg_11.jpg"
                                className="attachment-large size-large wp-image-177 service-card-img"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-79fc7a78 wastix_img_02 elementor-widget elementor-widget-image"
                            data-id="79fc7a78"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={202}
                                height={173}
                                src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/icon-bg-1.png"
                                className="attachment-large size-large wp-image-164"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-6d96b724 wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                            data-id="6d96b724"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-13" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-1ae86113 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                            data-id="1ae86113"
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="https://23july.hostlin.com/wastix/dumpster-rental/">
                                    <span className="elementor-icon-list-text">
                                      Hazardous Waste Management
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-6de6d2c2 elementor-widget elementor-widget-text-editor"
                            data-id="6de6d2c2"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              Efficient hazardous waste disposal ensures a safer
                              future.
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-6ffea71b elementor-view-framed wastix_boxshadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                            data-id="6ffea71b"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <Link
                                  className="elementor-icon"
                                  to="/hazardous-waste-management"
                                >
                                  <i aria-hidden="true" className="icon-7" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-4b306285 wastix_services_clomun wastix_services_clomun_01"
                        data-id="4b306285"
                        data-element_type="column"
                        data-settings='{"background_background":"classic"}'
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-6424080f wastix_industry_img_01 elementor-widget elementor-widget-image"
                            data-id="6424080f"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container service-img-wrapper">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={350}
                                height={210}
                                src="/containimg_12.jpg"
                                className="attachment-large size-large wp-image-176"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-41aa9b24 wastix_img_02 elementor-widget elementor-widget-image"
                            data-id="41aa9b24"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={202}
                                height={173}
                                src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/icon-bg-1.png"
                                className="attachment-large size-large wp-image-164"
                                alt=""
                              />
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-13136a0a wastix_icon_02 elementor-view-default elementor-widget elementor-widget-icon"
                            data-id="13136a0a"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-14" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-53681287 elementor-align-center elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                            data-id={53681287}
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="https://23july.hostlin.com/wastix/waste-collection/">
                                    <span className="elementor-icon-list-text">
                                      Bio-Medical Waste Management
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-dc81428 elementor-widget elementor-widget-text-editor"
                            data-id="dc81428"
                            data-element_type="widget"
                            data-widget_type="text-editor.default"
                          >
                            <div className="elementor-widget-container">
                              Safe biomedical waste management protects people
                              and planet from contamination.
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-63d5bfbc elementor-view-framed wastix_boxshadow_01 elementor-widget__width-initial elementor-shape-circle elementor-widget elementor-widget-icon"
                            data-id="63d5bfbc"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <Link
                                  className="elementor-icon"
                                  to="/bio-medical-waste-management"
                                >
                                  <i aria-hidden="true" className="icon-7" />
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </section>

          {/* live reach section   */}
          <CounterSection />

          {/* why choose us  */}
          <motion.section
            className="elementor-section elementor-top-section elementor-element elementor-element-375bdeb1 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="375bdeb1"
            data-element_type="section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.25 }}
            transition={{ duration: 1 }}
          >
            <div className="elementor-container elementor-column-gap-no">
              {/* LEFT SIDE SLIDE LEFT */}
              <motion.div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-903e208"
                data-id="903e208"
                data-element_type="column"
                variants={slideLeft}
                transition={{ duration: 1, ease: "easeOut" }}
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div
                    className="elementor-element elementor-element-764e7ab6 elementor-widget elementor-widget-image"
                    data-id="764e7ab6"
                    data-element_type="widget"
                    data-widget_type="image.default"
                  >
                    <div className="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width={525}
                        height={696}
                        src="/Men....png"
                        className="attachment-large size-large wp-image-214"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-19a29e0a wastix_img_animation_02 elementor-widget__width-auto elementor-absolute elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image"
                    data-id="19a29e0a"
                    data-element_type="widget"
                    data-settings='{"_position":"absolute"}'
                  >
                    <div className="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width={113}
                        height={108}
                        src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-8.png"
                        className="attachment-large size-large wp-image-240"
                        alt=""
                      />
                    </div>
                  </div>

                  <div
                    className="elementor-element elementor-element-52c878b6 elementor-absolute wastix_img_animation_01 elementor-hidden-tablet elementor-hidden-mobile elementor-widget elementor-widget-image"
                    data-id="52c878b6"
                  >
                    <div className="elementor-widget-container">
                      <img
                        loading="lazy"
                        decoding="async"
                        width={213}
                        height={213}
                        src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-2.png"
                        className="attachment-large size-large wp-image-150"
                        alt=""
                      />
                    </div>
                  </div>

                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-2b8150db wastix_block_02 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="2b8150db"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-579d3b76"
                        data-id="579d3b76"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-53913f8a elementor-view-framed elementor-shape-circle elementor-widget elementor-widget-icon"
                            data-id="53913f8a"
                            data-element_type="widget"
                            data-widget_type="icon.default"
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-18" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-211d9127"
                        data-id="211d9127"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-7a1b9939 elementor-widget elementor-widget-heading"
                            data-id="7a1b9939"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                For Emergency
                              </h2>
                            </div>
                          </div>

                          <div
                            className="elementor-element elementor-element-6fa89993 elementor-widget elementor-widget-icon-list"
                            data-id="6fa89993"
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-text">
                                      +91 9439366515
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </motion.div>

              {/* RIGHT SIDE SLIDE RIGHT */}
              <motion.div
                className="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-3360670c"
                data-id="3360670c"
                data-element_type="column"
                variants={slideRight}
                transition={{ duration: 1, ease: "easeOut" }}
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <div className="elementor-element elementor-element-394f1305 elementor-widget elementor-widget-heading">
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        Why Choose Us
                      </h2>
                    </div>
                  </div>

                  <div className="elementor-element elementor-element-729667d2 elementor-widget elementor-widget-heading">
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        Why choose our waste disposal services
                      </h2>
                    </div>
                  </div>

                  <div className="elementor-element elementor-element-7b920bef elementor-widget elementor-widget-text-editor">
                    <div className="elementor-widget-container">
                      At Green Circle Environment, we are driven by a passion to
                      create a cleaner, healthier, and sustainable world..
                    </div>
                  </div>

                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-67fed68c elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="67fed68c"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-978dd63">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-11a6a55c elementor-view-framed elementor-shape-circle elementor-widget elementor-widget-icon">
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-19" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-5e3f4f26"
                        data-id="5e3f4f26"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-1a535a28 elementor-widget elementor-widget-heading">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Residential and Industrial Waste Pick-Up
                              </h2>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-66e2f36b elementor-widget elementor-widget-text-editor">
                            <div className="elementor-widget-container">
                              Timely collections for clean homes, ensuring
                              proper sorting and eco-friendly disposal.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <section className="elementor-section elementor-inner-section elementor-element elementor-element-6fe58067 elementor-section-boxed elementor-section-height-default elementor-section-height-default">
                    <div className="elementor-container elementor-column-gap-no">
                      <div className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-3371d379">
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-69a9de37 elementor-view-framed elementor-shape-circle elementor-widget elementor-widget-icon">
                            <div className="elementor-widget-container">
                              <div className="elementor-icon-wrapper">
                                <div className="elementor-icon">
                                  <i aria-hidden="true" className=" icon-20" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div
                        className="elementor-column elementor-col-50 elementor-inner-column elementor-element elementor-element-192b9756"
                        data-id="192b9756"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div className="elementor-element elementor-element-65749caa elementor-widget elementor-widget-heading">
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Expertise and Quality Service
                              </h2>
                            </div>
                          </div>
                          <div className="elementor-element elementor-element-51ef6e2d elementor-widget elementor-widget-text-editor">
                            <div className="elementor-widget-container">
                              Skilled professionals deliver innovative,
                              certified environmental solutions with trusted,
                              reliable performance every time.
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>

                  <div className="elementor-element elementor-element-49e1016b wastix_btn_01 elementor-widget elementor-widget-button"></div>
                </div>
              </motion.div>
            </div>
          </motion.section>

          {/* book service */}
          <motion.section
            className="elementor-section elementor-top-section elementor-element elementor-element-772018bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="772018bb"
            data-element_type="section"
            data-settings='{"background_background":"classic","shape_divider_bottom":"curve","shape_divider_bottom_negative":"yes"}'
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: "easeOut" }}
            variants={fadeUp}
          >
            <div className="elementor-background-overlay" />

            <div
              className="elementor-shape elementor-shape-bottom"
              aria-hidden="true"
              data-negative="true"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1000 100"
                preserveAspectRatio="none"
              >
                <path
                  className="elementor-shape-fill"
                  d="M500,97C126.7,96.3,0.8,19.8,0,0v100l1000,0V1C1000,19.4,873.3,97.8,500,97z"
                />
              </svg>
            </div>

            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-6e90903e"
                data-id="6e90903e"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-2548ac57 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="2548ac57"
                    data-element_type="section"
                  >
                    <div className="elementor-container elementor-column-gap-no">
                      <div
                        className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-38391c5c"
                        data-id="38391c5c"
                        data-element_type="column"
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          {/* Heading animated */}
                          <motion.div
                            className="elementor-element elementor-element-6827a42f elementor-widget elementor-widget-heading"
                            data-id="6827a42f"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                            variants={fadeDown}
                            transition={{ duration: 1, ease: "easeOut" }}
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Become our customer &amp; get special service
                              </h2>
                            </div>
                          </motion.div>

                          {/* Button animated */}
                          <motion.div
                            className="elementor-element elementor-element-b6b6519  wastix_btn_01 elementor-widget__width-auto elementor-mobile-align-center elementor-widget-mobile__width-inherit elementor-widget elementor-widget-button"
                            data-id="b6b6519"
                            data-element_type="widget"
                            data-widget_type="button.default"
                            variants={fadeUp}
                            transition={{ duration: 1.1, ease: "easeOut" }}
                          >
                            <div className="elementor-widget-container">
                              <div className="elementor-button-wrapper">
                                <Link
                                  className="elementor-button elementor-button-link elementor-size-sm"
                                  to="/contact-us"
                                >
                                  <span className="elementor-button-content-wrapper">
                                    <span className="elementor-button-text">
                                      Contact Us
                                    </span>
                                  </span>
                                </Link>
                              </div>
                            </div>
                          </motion.div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </motion.section>

          {/* recycle materials */}
          <motion.section
            className="elementor-section elementor-top-section elementor-element elementor-element-7ace294b elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="7ace294b"
            data-element_type="section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 1, ease: "easeOut" }}
            variants={fadeIn}
          >
            <div className="elementor-container elementor-column-gap-no">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-49d58aa1"
                data-id="49d58aa1"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  <section
                    className="elementor-section elementor-inner-section elementor-element elementor-element-6531ac78 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                    data-id="6531ac78"
                    data-element_type="section"
                    data-settings='{"background_background":"classic"}'
                  >
                    <div className="elementor-background-overlay" />
                    <div className="elementor-container elementor-column-gap-no">
                      {/* LEFT COLUMN – SLIDE FROM LEFT */}
                      <motion.div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-6a5dcc19"
                        data-id="6a5dcc19"
                        data-element_type="column"
                        variants={slideLeft}
                        transition={{ duration: 1, ease: "easeOut" }}
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-446d4ee1 elementor-widget elementor-widget-heading"
                            data-id="446d4ee1"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                Recycle Materials
                              </h2>
                            </div>
                          </div>
                          <div
                            className="elementor-element elementor-element-7152fb5f elementor-widget elementor-widget-heading"
                            data-id="7152fb5f"
                            data-element_type="widget"
                            data-widget_type="heading.default"
                          >
                            <div className="elementor-widget-container">
                              <h2 className="elementor-heading-title elementor-size-default">
                                We collect, recycle &amp; disposal all materials
                              </h2>
                            </div>
                          </div>
                        </div>
                      </motion.div>

                      {/* MIDDLE COLUMN – FADE / SCALE IN */}
                      <motion.div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-5a161c71"
                        data-id="5a161c71"
                        data-element_type="column"
                        variants={fadeIn}
                        transition={{
                          duration: 1,
                          delay: 0.15,
                          ease: "easeOut",
                        }}
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-67ab4145 wastix_img_animation_02 elementor-widget__width-auto elementor-widget elementor-widget-image"
                            data-id="67ab4145"
                            data-element_type="widget"
                            data-widget_type="image.default"
                          >
                            <div className="elementor-widget-container">
                              <img
                                loading="lazy"
                                decoding="async"
                                width={113}
                                height={108}
                                src="https://23july.hostlin.com/wastix/wp-content/uploads/2024/01/shape-10.png"
                                className="attachment-large size-large wp-image-269"
                                alt=""
                              />
                            </div>
                          </div>
                        </div>
                      </motion.div>

                      {/* RIGHT COLUMN – SLIDE FROM RIGHT */}
                      <motion.div
                        className="elementor-column elementor-col-33 elementor-inner-column elementor-element elementor-element-24af075f"
                        data-id="24af075f"
                        data-element_type="column"
                        variants={slideRight}
                        transition={{
                          duration: 1,
                          delay: 0.25,
                          ease: "easeOut",
                        }}
                      >
                        <div className="elementor-widget-wrap elementor-element-populated">
                          <div
                            className="elementor-element elementor-element-3a33a17c elementor-align-left icon_wastix_01 elementor-widget__width-auto elementor-widget-tablet__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                            data-id="3a33a17c"
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Steel
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Plastic
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Lights &amp; Bulbs
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Books &amp; Papers
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Bottles
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>

                          <div
                            className="elementor-element elementor-element-5c909708 elementor-align-left icon_wastix_01 elementor-widget__width-auto elementor-widget-tablet__width-inherit elementor-icon-list--layout-traditional elementor-list-item-link-full_width elementor-widget elementor-widget-icon-list"
                            data-id="5c909708"
                            data-element_type="widget"
                            data-widget_type="icon-list.default"
                          >
                            <div className="elementor-widget-container">
                              <ul className="elementor-icon-list-items">
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Food &amp; Grocery
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Common Waste
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Newspaper
                                    </span>
                                  </a>
                                </li>
                                <li className="elementor-icon-list-item">
                                  <a href="#">
                                    <span className="elementor-icon-list-icon">
                                      <svg
                                        aria-hidden="true"
                                        className="e-font-icon-svg e-fas-check"
                                        viewBox="0 0 512 512"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path>
                                      </svg>{" "}
                                    </span>
                                    <span className="elementor-icon-list-text">
                                      Food &amp; Grocery
                                    </span>
                                  </a>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </motion.section>

          {/* our partners */}
          <section className="py-5 bg-light">
            <Container>
              {/* Section Heading */}
              <div className="text-center mb-5">
                <h2
                  className="fw-bold display-6 text-dark"
                  style={{ color: "black" }}
                >
                  Our Partners
                </h2>
                <hr
                  style={{
                    width: "100px",
                    height: "3px",
                    backgroundColor: "green",
                    margin: "10px auto",
                    border: "none",
                  }}
                />
              </div>

              {/* Auto Sliding Client Logos */}
              <div className="client-carousel">
                <div className="carousel-track">
                  {/* Duplicate logos twice for smooth infinite loop */}
                  <img src="baripada.png" alt="Client 1" />
                  <img src="bmc.png" alt="Client 2" />
                  <img src="hal.png" alt="Client 3" />
                  <img src="east.png" alt="Client 4" />
                  <img src="jharsuguda.png" alt="Client 5" />
                  <img src="puri.png" alt="Client 6" />
                  <img src="os.png" alt="Client 7" />
                  <img src="baripada.png" alt="Client 1" />
                  <img src="bmc.png" alt="Client 2" />
                  <img src="hal.png" alt="Client 3" />
                  <img src="east.png" alt="Client 4" />
                  <img src="jharsuguda.png" alt="Client 5" />
                  <img src="puri.png" alt="Client 6" />
                  <img src="smc.png" alt="Client 7" />
                </div>
              </div>
            </Container>
          </section>

          {/* our articles */}
          <motion.section
            className="elementor-section elementor-top-section elementor-element elementor-element-6b66cb3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
            data-id="6b66cb3"
            data-element_type="section"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            variants={fadeUp}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <div className="elementor-container elementor-column-gap-default">
              <div
                className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-782d54c"
                data-id="782d54c"
                data-element_type="column"
              >
                <div className="elementor-widget-wrap elementor-element-populated">
                  {/* Top heading block */}
                  <motion.div
                    className="elementor-element elementor-element-75f6497 elementor-widget elementor-widget-heading"
                    data-id="75f6497"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                    variants={fadeUp}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        Our Articles
                      </h2>
                    </div>
                  </motion.div>

                  <motion.div
                    className="elementor-element elementor-element-f5ebef8 elementor-widget elementor-widget-heading"
                    data-id="f5ebef8"
                    data-element_type="widget"
                    data-widget_type="heading.default"
                    variants={fadeUp}
                    transition={{ duration: 0.9, delay: 0.1, ease: "easeOut" }}
                  >
                    <div className="elementor-widget-container">
                      <h2 className="elementor-heading-title elementor-size-default">
                        Get more update from <br />
                        Green circle
                      </h2>
                    </div>
                  </motion.div>

                  <div
                    className="elementor-element elementor-element-ebef4df elementor-widget elementor-widget-wpsection_wps_blog_grid"
                    data-id="ebef4df"
                    data-element_type="widget"
                    data-widget_type="wpsection_wps_blog_grid.default"
                  >
                    <div className="elementor-widget-container">
                      <section className="blog-grid">
                        <div className="auto-container">
                          <div className="row clearfix">
                            {/* CARD 1 */}
                            <motion.div
                              className="col-lg-4 col-md-4  col-sm-12 news-block"
                              variants={fadeUp}
                              transition={{
                                duration: 0.9,
                                delay: 0.1,
                                ease: "easeOut",
                              }}
                            >
                              <div
                                className="wp_blog_block news-block-two wow fadeInUp animated"
                                data-wow-delay="00ms"
                                data-wow-duration="1500ms"
                              >
                                <div className="inner-box">
                                  <div className="image-box">
                                    <figure className="image mr_product_thumb">
                                      <Link
                                        to="/blog"
                                        className="mr_product_link"
                                      >
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={850}
                                          height={560}
                                          src="se.png"
                                          className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                          alt=""
                                          srcSet="se.png"
                                          sizes="(max-width: 850px) 100vw, 850px"
                                        />
                                      </Link>
                                    </figure>
                                    <span className="post-date mr_post_date">
                                      25 Aug
                                    </span>
                                  </div>
                                  <div className="lower-content">
                                    <div className="subtitle_alignment">
                                      {/* <span className="category mr_block_subtitle mr_featured_block_subtitle">
                              <a href="">
                               Climate Risk Assessment For Your Business in 2025
                              </a>{" "}
                            </span> */}
                                    </div>
                                    <h3 className="mr_block_title mr_featured_block">
                                      <a href="">
                                        Climate Risk Assessment For Your
                                        Business in 2025
                                      </a>
                                    </h3>
                                    <ul className="post-info clearfix">
                                      <li className="author-box mr_block_author">
                                        <div className="author-thumb">
                                          <img
                                            alt=""
                                            src="se.png"
                                            srcSet=""
                                            className="avatar avatar-90 photo"
                                            height={90}
                                            width={90}
                                          />
                                        </div>
                                        <a href="">admin</a>
                                      </li>
                                      <li className="mr_featured_block mr_block_comment">
                                        <i className="" />2 Comments
                                      </li>
                                    </ul>
                                    <p className="mr_featured_block mr_f_block_text">
                                      Climate change is redefining numerous
                                      business working models across the world,
                                      and in India, the stakes are particularly…
                                    </p>
                                    <div className="wps_read_button_area">
                                      <button className="wps_read_button">
                                        <Link
                                          className="theme_btn_none"
                                          to="/blog"
                                        >
                                          Read More
                                        </Link>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </motion.div>

                            {/* CARD 2 */}
                            <motion.div
                              className="col-lg-4 col-md-4  col-sm-12 news-block"
                              variants={fadeUp}
                              transition={{
                                duration: 0.9,
                                delay: 0.2,
                                ease: "easeOut",
                              }}
                            >
                              <div
                                className="wp_blog_block news-block-two wow fadeInUp animated"
                                data-wow-delay="00ms"
                                data-wow-duration="1500ms"
                              >
                                <div className="inner-box">
                                  <div className="image-box">
                                    <figure className="image mr_product_thumb">
                                      <Link
                                        to="/blog"
                                        className="mr_product_link"
                                      >
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={850}
                                          height={560}
                                          src="fr.png"
                                          className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                          alt=""
                                          srcSet="fr.png"
                                          sizes="(max-width: 850px) 100vw, 850px"
                                        />
                                      </Link>
                                    </figure>
                                    <span className="post-date mr_post_date">
                                      22 Aug
                                    </span>
                                  </div>
                                  <div className="lower-content">
                                    <div className="subtitle_alignment">
                                      {/* <span className="category mr_block_subtitle mr_featured_block_subtitle">
                              <a href="https://23july.hostlin.com/wastix/category/dumpster-rental/">
                                Dumpster rental
                              </a>{" "}
                            </span> */}
                                    </div>
                                    <h3 className="mr_block_title mr_featured_block">
                                      <a href="">
                                        Harnessing Drone Technology for
                                        Environmental Monitoring in 2025
                                      </a>
                                    </h3>
                                    <ul className="post-info clearfix">
                                      <li className="author-box mr_block_author">
                                        <div className="author-thumb">
                                          <img
                                            alt=""
                                            src="https://secure.gravatar.com/avatar/231e85211ec2e847c12725fd74d10ce430efe989f0ad1394685d6bcbdce36686?s=90&d=mm&r=g"
                                            srcSet="https://secure.gravatar.com/avatar/231e85211ec2e847c12725fd74d10ce430efe989f0ad1394685d6bcbdce36686?s=180&d=mm&r=g 2x"
                                            className="avatar avatar-90 photo"
                                            height={90}
                                            width={90}
                                          />
                                        </div>
                                        <a href="">admin</a>
                                      </li>
                                      <li className="mr_featured_block mr_block_comment">
                                        <i className="" />
                                        No Comments
                                      </li>
                                    </ul>
                                    <p className="mr_featured_block mr_f_block_text">
                                      Traditional ground surveys, manual
                                      sampling, and satellite imaging, often
                                      face limitations such as high costs, time
                                      delays,…
                                    </p>
                                    <div className="wps_read_button_area">
                                      <button className="wps_read_button">
                                        <Link
                                          className="theme_btn_none"
                                          to="/blog"
                                        >
                                          Read More
                                        </Link>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </motion.div>

                            {/* CARD 3 */}
                            <motion.div
                              className="col-lg-4 col-md-4  col-sm-12 news-block"
                              variants={fadeUp}
                              transition={{
                                duration: 0.9,
                                delay: 0.3,
                                ease: "easeOut",
                              }}
                            >
                              <div
                                className="wp_blog_block news-block-two wow fadeInUp animated"
                                data-wow-delay="00ms"
                                data-wow-duration="1500ms"
                              >
                                <div className="inner-box">
                                  <div className="image-box">
                                    <figure className="image mr_product_thumb">
                                      <a className="mr_product_link" href="">
                                        <img
                                          loading="lazy"
                                          decoding="async"
                                          width={850}
                                          height={560}
                                          src="wl.png"
                                          className="attachment-post-thumbnail size-post-thumbnail wp-post-image"
                                          alt=""
                                          scret="wl.png"
                                          sizes="(max-width: 850px) 100vw, 850px"
                                        />
                                      </a>
                                    </figure>
                                    <span className="post-date mr_post_date">
                                      06 Aug
                                    </span>
                                  </div>
                                  <div className="lower-content">
                                    <div className="subtitle_alignment">
                                      {/* <span className="category mr_block_subtitle mr_featured_block_subtitle">
                              <a href="https://23july.hostlin.com/wastix/category/waste-collection/">
                                Waste collection
                              </a>{" "}
                            </span> */}
                                    </div>
                                    <h3 className="mr_block_title mr_featured_block">
                                      <a href="">
                                        7 Critical Environmental Regulations in
                                        Service Based Industry
                                      </a>
                                    </h3>
                                    <ul className="post-info clearfix">
                                      <li className="author-box mr_block_author">
                                        <div className="author-thumb">
                                          <img
                                            alt=""
                                            src=""
                                            srcSet=""
                                            className="avatar avatar-90 photo"
                                            height={90}
                                            width={90}
                                          />
                                        </div>
                                        <a href="">admin</a>
                                      </li>
                                      <li className="mr_featured_block mr_block_comment">
                                        <i className="" />
                                        No Comments
                                      </li>
                                    </ul>
                                    <p className="mr_featured_block mr_f_block_text">
                                      What if the smallest choices your business
                                      makes today impact the environmental
                                      regulations tomorrow? Service-based
                                      industries…
                                    </p>
                                    <div className="wps_read_button_area">
                                      <div className="wps_read_button_area">
                                        <button className="wps_read_button">
                                          <Link
                                            className="theme_btn_none"
                                            to="/blog"
                                          >
                                            Read More
                                          </Link>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </motion.div>
                          </div>
                        </div>
                      </section>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.section>
        </div>

        <Footer />

        {/* scroll to top */}
        {/*Scroll to top*/}
        <div className="mr_scroll-to-top">
          <div>
            <div className="mr_scroll-top-inner">
              <div className="mr_scroll-bar">
                <div className="mr_bar-inner" />
              </div>
              <div className="mr_bar_icon">
                <i className="fas fa-arrow-left" />
              </div>
            </div>
          </div>
        </div>
        {/* Scroll to top end */}
        {/* Scroll to top end */}
        {/*Search Popup*/}
        
        {/* Visitors Counter - Left Side */}
        <VisitorsCounter />
        
        {/* Chatbot - Right Side */}
        <Chatbot />
      </main>
    </>
  );
}
